import React from "react";
import shallow from "zustand/shallow";
import { FunnelSimple } from "phosphor-react";
import useNotificationStore from "../../stores/useNotificationStore";
import NotificationFooter from "./NotificationFooter";
import useNotificationActions from "../../hooks/notifications/useNotificationActions";
import useNotificationsList from "../../hooks/notifications/useNotificationsList";
import styles from "./NotificationFeed.module.css";
import Skeleton from "../Skeleton/Skeleton";

const NotificationFeed = (props) => {
  const { isModal } = props;
  const { isFetching, fetchLatest, toggleFilter, content } = useNotificationsList(isModal);
  const { viewNotification, markAllNotificationsAsRead } = useNotificationActions(fetchLatest);
  const { filterButtonName, filterButtonClass, iconColour, filterMessage, noDataMsg } = content;
  const { shortList, longList, hasUnread } = useNotificationStore(
    (state) => ({
      shortList: state.shortList,
      longList: state.longList,
      hasUnread: state.hasUnread,
    }),
    shallow
  );

  const notifications = isModal ? shortList : longList;

  const listedNotifications = notifications?.map((notification, i) => {
    const { isRead, message, url } = notification;

    const splitMessage = message.split(":");
    const leadMessage = splitMessage[0];
    const trailingMessage = splitMessage[1];
    const splitTrailingMessage = trailingMessage?.split(",");

    return (
      <div key={i} className={styles.notifications}>
        <div
          aria-label={!isRead ? "Unread Notification" : "Read Notification"}
          onClick={(e) => viewNotification(e, notification)}
          onKeyDown={(e) => viewNotification(e, notification)}
          className={`${styles.notifications__content} ${
            isRead ? "" : `${styles.newNotification}`
          }`}
          role="button"
          tabIndex={0}
          data-path={url}
        >
          <p className={styles.notifications__content_paragraph}>
            <span className={styles.styles.notifications__content_noStyle}>{leadMessage}:</span>

            <span className={styles.notifications__content_bold}>
              {splitTrailingMessage ? splitTrailingMessage[0] : ""}
            </span>
            <span className={styles.styles.notifications__content_noStyle}>
              {splitTrailingMessage ? splitTrailingMessage[1] : ""}
            </span>
            <span className={styles.notifications__content_bold}>
              {splitTrailingMessage ? splitTrailingMessage[2] : ""}
            </span>
          </p>
        </div>
      </div>
    );
  });

  const renderFeedContent = () => {
    let feedContent = (
      <div className={styles[isModal ? "skel_wrapper_modal" : "skel_wrapper"]}>
        <Skeleton
          wrapperwidth={isModal ? 200 : 500}
          wrapperheight={isModal ? 50 : 100}
          rectwidth={isModal ? 150 : 410}
          rectheight={isModal ? 12 : 20}
        />
      </div>
    );
    if (!isFetching && notifications) {
      if (notifications.length > 0) {
        feedContent = listedNotifications;
      } else {
        feedContent = (
          <p aria-label={noDataMsg} className={styles.noNotifications}>
            {noDataMsg}
          </p>
        );
      }
    }
    return feedContent;
  };

  return (
    <div className={styles[isModal ? "notificationsModalContainer" : "notificationsContainer"]}>
      {!isModal && (
        <div className={styles.row}>
          <button
            id="tabToMe"
            className={`${styles.filter_button} ${styles[filterButtonClass]}`}
            type="button"
            name={filterButtonName}
            aria-label={filterButtonName}
            onClick={toggleFilter}
          >
            <FunnelSimple size={20} color={iconColour} weight="bold" />
            Unread
          </button>
          {filterMessage && <span className={styles.filterMessage}>{filterMessage}</span>}
          <button
            type="button"
            name="Mark all notifications as red"
            aria-label="Mark all notifications as red"
            className={styles.markAllAsRead}
            onClick={() => markAllNotificationsAsRead(hasUnread)}
          >
            Mark all as read
          </button>
        </div>
      )}
      {renderFeedContent()}
      {isModal && notifications?.length ? <NotificationFooter /> : <div></div>}
    </div>
  );
};

export default NotificationFeed;
